module.exports = __webpack_public_path__ + "img/spot_c.56e31923.png";